export const messages = {
    required: 'Required',
    invalidURL: 'Please enter a valid URL',
    disallowSpaces: 'Entering only spaces is not a valid input'
};
